import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const productPricingWithFiltersTodo = createAsyncThunk('productPricingWithFilters', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + 'product-pricing-with-filters',
            params: {
                'itemName': data?.item,
                'customerId': data?.customer,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const productPricingWithFiltersSlice = createSlice({
    name: 'productPricingWithFilters',
    initialState: {
        data: [],
    },
    reducers: {
        removeItems: (state, action) => {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        builder.addCase(productPricingWithFiltersTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(productPricingWithFiltersTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export const { removeItems } = productPricingWithFiltersSlice.actions;
export default productPricingWithFiltersSlice.reducer; 